export default "__VITE_ASSET__DZyZGt$r__"